export enum SecondaryApiTypeEnum {
    FIREBLOCKS = '1',
    DELETE = 'D'
}

type SecondaryApiTypeMap = Record<
    SecondaryApiTypeEnum,
    {
        displayValue: string;
        value: SecondaryApiTypeEnum;
    }
>;

export const SecondaryApiTypeMap: SecondaryApiTypeMap = {
    [SecondaryApiTypeEnum.FIREBLOCKS]: {
        displayValue: 'Fireblocks API',
        value: SecondaryApiTypeEnum.FIREBLOCKS
    },
    [SecondaryApiTypeEnum.DELETE]: {
        displayValue: 'Delete API Provider',
        value: SecondaryApiTypeEnum.DELETE
    }
};